import React, { useState } from 'react'
import { CardElement } from '@stripe/react-stripe-js'

const ElementField = ({
  stripeElements,
  resetStripeErrors,
  errors,
  label = 'Card details',
  labelClass = 'sr-only visually-hidden',
}) => {
  const [ state, setState ] = useState({})

  const handleChange = e => {
    setState(e)
    resetStripeErrors()
  }

  const error = state.error?.message || errors?.stripe?.[0]
  // Bootstrap 4–5 workaround; hopefully we'll discover a better way later
  const options = error ? {
    ...stripeElements,
    classes: {
      ...stripeElements.classes,
      base: `${stripeElements.classes.base} is-invalid`,
    },
  } : stripeElements

  return (
    <div className={`form-group mb-3 ${error ? 'has-error' : ''}`}>
      <label style={{ display: 'block', marginBottom: 0, fontWeight: 'normal' }}>
        <label className={labelClass}>{label}</label>
        <CardElement
          onChange={handleChange}
          options={{ ...options, hidePostalCode: true }}
        />
        {
          error &&
          <div className="help-block invalid-feedback" aria-live="assertive">
            {error}
          </div>
        }
      </label>
    </div>
  )
}

export default ElementField
